<template>
  <div class="div-unit">
    <div class="div-title">
      <div class="div-text">
        {{ unitTitle }}
        <span v-html="customHTML"></span>
      </div>
      <div
        @click="show1 = !show1"
        class="div-tool"
        title="Click to show or hide the detail information"
        style="cursor: pointer"
      >
        <i v-show="show1" class="fa fa-chevron-down"></i>
        <i v-show="!show1" class="fa fa-chevron-right"></i>
      </div>
    </div>
    <el-collapse-transition>
      <div v-show="show1" class="div-content" style="padding: 20px">
        <slot></slot>
      </div>
    </el-collapse-transition>
  </div>
</template>
  
  <script>
export default {
  name: "DivUnit",
  data() {
    return {
      show1: true,
    };
  },
  props: {
    unitTitle: String,
    customHTML: String,
    // required: true,
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
  